var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2703 0.00711002C19.7881 -0.417907 0.432097 18.2652 0.0070795 41.7297C-0.417938 65.1942 18.2651 84.5679 41.7296 84.9929C65.1941 85.4179 84.5678 66.7348 84.9929 43.2526C85.4179 19.7881 66.7348 0.414418 43.2703 0.00711002ZM41.8713 77.0238C22.8341 76.6696 7.62198 60.9086 7.97616 41.8713C8.31263 22.8341 24.0737 7.62201 43.1109 7.95848C62.1659 8.31266 77.3603 24.0737 77.0238 43.111C76.6873 62.1482 60.9085 77.3603 41.8713 77.0238Z",
    fill: "#374C98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0613 11.5074C25.9721 11.2063 11.8226 24.86 11.5215 41.9492C11.2027 59.0208 24.8564 73.1703 41.9457 73.4891C59.0349 73.7901 73.1845 60.1365 73.4855 43.0649C73.7866 25.9757 60.1506 11.8261 43.0613 11.5074ZM55.8296 60.4906H27.6368L31.09 41.3826L27.0878 42.2149V38.9564L31.6921 37.9824L34.685 21.5484H45.9302L43.3801 35.5386L47.3115 34.7062V37.9647L42.778 38.9033L40.1571 53.3539H57.9192L55.8296 60.4906Z",
    fill: "#374C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLit3);
export default __webpack_public_path__ + "static/media/lit3.09c8aed0bc86c8b2ec2d6b8880481e46.svg";
export { ForwardRef as ReactComponent };